{
  "SIGNUP PAGE": "====================",
  "Введите_имя": "Specify name",
  "Введите_email": "Specify e-mail",
  "Введите_пароль": "Specify password",
  "Пароль_не_менее": "Password minimum 8 symbols",
  "Повторный_пароль_не_совпадает": "Repeated password does not match",
  "Ознакомьтесь_с_Политикой_и_Офертой": "Please review the Policy and Offer.",
  "Email_не_валидный": "E-mail is invalid",
  "Email_уже_используется": "E-mail is already used",
  "Некорректный_рефкод": "Invalid partner code",
  "Регистрация": "Signup",
  "Войдите": "Login",
  "Есть_аккаунт": "Have an account",
  "Ваше_имя": "Your name",
  "Ваш_email": "Your e-mail",
  "Ваш_пароль": "Your password",
  "Подтвердите_пароль": "Confirm password",
  "Код_партнера": "Partner code (not necessarily)",
  "Зарегистрироваться": "Signup",
  "с": "with the",
  "Публичной_офертой": "Public offer",
  "и": "and",
  "Политикой_конфиденциальности": "Privacy policy",
  "ознакомлен": "i have reviewed",
  "На_ваш_e_mail": "A confirmation code has been sent to your email address",
  "был_отправлен_код": ".",
  "Пожалуйста_нажмите_кнопку": "Please click the 'Confirm Registration' button in the email.",
  "Вернуться_ко_входу": "Back to Login",

  "LOGIN PAGE": "====================",
  "Логин_или_пароль_не_найдены": "Login or password not found",
  "Email_не_верифицирован": "Email not verified",
  "Вход": "Login",
  "Нет_аккаунта": "No account",
  "Войти": "Login",
  "Забыли_пароль": "Forgot password",

  "FORGOT PASSWORD PAGE": "====================",
  "Успешно": "Successfully",
  "Письмо_с_инструкцией": "An e-mail with instructions for password recovery has been sent to your e-mail address",
  "Перейти_ко_входу": "Go to login",
  "Восстановление_пароля": "Password\nrecovery",
  "Восстановить": "Recover",
  "Я_вспомнил_пароль": "I remembered my password, go back.",
  "Введите_код": "Enter code",
  "Формат_поля_6_цифр": "Field format: 6 digits",
  "Почта_уже_используется": "Email is already used",
  "Код_недействителен": "Code is invalid or expired",
  "Почта_не_найдена": "Email not found",

  "PASSWORD RESET PAGE": "====================",
  "Укажите_новый_пароль": "Specify a new password",
  "Подтверждение": "Confirmation",
  "Данные_успешно_обновлены": "Data successfully accepted",
  "Можно_выполнить_вход": "You can now login",
  "Смена_пароля": "Reset\npassword",
  "Новый_пароль": "New password",
  "Обновить_пароль": "Update password",

  "CALENDAR": "====================",
  "Выберите_пресет": "Select preset",
  "За_все_время": "All",
  "Неделя": "Week",
  "Месяц": "Month",
  "Квартал": "Quarter",
  "Год": "Year",

  "Для_отображения_своего_периода": "To display your custom period, follow these steps",
  "Выделите_начальную_дату": "Select the start date",
  "Укажите_конечную_дату": "Specify the end date",
  "Фильтр_автоматически_применится_и_отобразит": "The filter will automatically apply and display the data for the selected period",
  "Если_нужен_период_более": "If you need a period longer than one month",
  "Прокрутите_календарь": "Scroll the calendar to the desired month",
  "Укажите_начальную_дату": "Specify the start date",
  "Прокрутите_календарь_до_необходимого": "Scroll the calendar to the necessary month and specify the end date",
  "Фильтр_автоматически_применится": "The filter will automatically apply",

  "Common Periods": "====================",
  "Воскресенье": "Sunday",
  "Понедельник": "Monday",
  "Вторник": "Tuesday",
  "Среда": "Wednesday",
  "Четверг": "Thursday",
  "Пятница": "Friday",
  "Суббота": "Saturday",
  "месяц": "month",
  "месяца": "months",
  "месяцев": "months",

  "INPUT": "====================",
  "Формат_данных": "Data format",
  "Введите_корректный_email": "Specify correct e-mail",
  "Введите_корректный_номер_счета": "Specify correct account number",

  "FAQ": "====================",
  "faq": "FAQ",

  "Footer": "====================",
  "Публичная_оферта": "Public offer",
  "Политика_конфиденциальности": "Privacy policy",

  "Header": "====================",
  "Выйти": "Logout",
  "Тема": "Theme",
  "Язык": "Language",
  "Онлайн_мониторинг": "Online monitoring",
  "Партнерка": "Partnership",
  "Балансовые_операции": "Balance operations",
  "Поддержка": "Support",

  "No data": "====================",
  "Список_на_данный_момент_пуст": "List is empty at the moment",
  "нет_данных": "no data",

  "Pagination": "====================",
  "Всего_найдено": "Total found",

  "Common Payment methods": "====================",
  "Метод_оплаты": "Payment method",
  "Банковская_карта": "Bank card",
  "Электронный_кошелек": "E-wallet",
  "Криптокошелек": "Crypto wallet",
  "Баланс_ЛК": "Account balance",
  "Укажите_метод_оплаты": "Select payment method",

  "Payment Balance": "====================",
  "Недостаточно_средств": "Insufficient funds for payment.",
  "Оплата_успешно": "Payment was successful",
  "Идентификатор_транзакции_уже_используется": "The transaction id has already been taken",
  "Оплата_с_баланса": "Payment from balance",
  "Сумма_платежа": "Payment amount",
  "Назад": "Back",
  "Оплатить": "Pay",

  "Payment Bank": "====================",
  "Номер_нашей_карты_скопирован": "Our card number has been copied",
  "Ваш_email_скопирован": "Your e-mail has been copied",
  "Укажите_Вашу_карту": "Please enter your card details",
  "Нет_сигнатуры": "There is no signature to complete the payment",
  "Платеж_в_обработке": "Payment is processing",
  "Оплата_с_банковской_карты": "Payment with a bank card",
  "Комиссия": "Commission",
  "Комиссия_включена": "Commission included",
  "Платежные_системы": "Payment systems",
  "Наша": "Our",
  "карта": "card",
  "Введите_вашу_карту": "Please enter your card details",
  "Подтвердить_оплату": "Confirm payment",
  "ВНИМАНИЕ_После_отправки": "ATTENTION! After sending funds, click NOTIFY ABOUT PAYMENT. FIRST SEND THE MONEY, THEN CLICK THE BUTTON.",
  "Данная_платежная_система": "This payment system has a minimum transaction limit of",
  "Пожалуйста_используйте_другой_метод": "Please use a different payment method.",

  "Payment Crypto": "====================",
  "Адрес_нашего_кошелька_скопирован": "Our wallet address has been copied.",
  "Укажите_ваш_кошелек": "Specify your wallet",
  "Укажите_TXID": "Specify TXID",
  "Оплата_криптовалютой": "Payment with cryptocurrency.",
  "адрес_кошелька_для_оплаты": "wallet address for payment.",
  "Отсканируйте_код_кошелька": "Scan the wallet QR code.",
  "Введите_ваш_кошелек": "Enter your wallet address.",
  "TXID_транзакции": "Transaction TXID",
  "Идентификатор_транзакции": "A Transaction ID (TxID), or transaction hash, is a unique string of characters assigned to each transaction that is verified and added to the blockchain. In other words, the TxID is an identification number that tags each transaction on the blockchain. A Transaction ID (TxID) might look something like this: b20sefa5*********922f1ae884",
  "Для_оплаты_заказа_переведите": "To pay for your order, transfer funds to the wallet address specified in the 'Wallet Address for Payment' field. After making the transfer, click the 'Confirm Payment' button.",

  "Payment Wallet": "====================",
  "Оплата_электронным_кошельком": "Payment with an e-wallet",
  "Наш": "Our",
  "кошелек": "wallet",

  "VPS PAGE": "====================",
  "Приветствуем": "Hello",

  "VPS PAGE Rates": "====================",
  "Укажите_период": "Select period",
  "Введите_промокод": "Enter the promo code",
  "Процессор": "Processor",
  "Память": "Memory",
  "Диск": "Hard-disk drive",
  "ОС": "OS",
  "Терминалы": "Terminals",
  "Трафик": "Traffic",
  "безлимитный": "unlimited",
  "мес": "monthes",
  "Срок_аренды": "Rental period",
  "Промокод": "Promocode",
  "Заказать": "Order",
  "скидка": "discount",

  "Укажите_источник": "Specify source",
  "Заявка_на_Тестовый": "Your request for a Test Server is under review",
  "Тестовый_сервер_уже_заказан": "The test server has already been ordered",
  "Тестовый_сервер": "Test server",
  "дня": "days",
  "Откуда_узнали_о_нас": "How did you hear about us?",

  "VPS PAGE Rates = Modal Buy": "====================",
  "Введите_сумму": "Enter the amount",
  "Подтверждение_действия": "Action confirmation",
  "Если_вы_хотите_арендовать_новый": "If you want to rent a new VPS, click the 'Next' button. If you intend to extend the lease of your current VPS, close this window, go to the 'VPS Servers' section, and click the 'Renew' button",
  "Оплата_тарифа": "Payment of the tariff",

  "Заявка_на_тестовый_доступ": "Your request for test access to the server has been successfully submitted. According to the regulations, requests are processed within one business day. You will receive a notification via e-mail once the request has been processed.",

  "VPS PAGE Servers": "====================",
  "серверы": "servers",

  "Поиск_по_ID": "Search by ID",

  "Все": "All",
  "Активный": "Active",
  "Заблокирован": "Blocked",
  "Отозван": "Revoked",

  "VPS PAGE Servers Table Header": "====================",
  "Тариф": "Tariff",
  "Комментарий": "Comment",
  "Данные_для_входа": "Login details",
  "Выдан": "Issued",
  "Оплачен_до": "Paid until",
  "Продление": "Renewal",
  "Автопродление": "Auto-renewal",
  "Автопродление_позволит": "Auto-renewal allows you to automatically pay for the extension of your VPS rental from your personal account balance. To activate this feature, ensure that your personal account balance is topped up with the required amount.",
  "Статус": "Status",

  "VPS PAGE Servers Table Content": "====================",
  "Функция_автопродления_выключена": "Auto-renewal function is disabled",
  "Функция_автопродления_подключена": "Auto-renewal function is enabled",
  "Показать": "Show",
  "данные_для_входа": "login details",
  "Продлить": "Renew",

  "Принять": "Confirm",
  "Отменить": "Cancel",

  "VPS PAGE Servers Modal Upgrade": "====================",
  "Выберите_тариф_для_апгрейда": "Choose upgrade tariff",
  "Укажите_дату_проведения_апгрейда": "Specify the date of the upgrade",
  "Заявка_на_апгрейд_сервера_отправлена": "Upgrade tariff request sent successfull",
  "Заявка_на_апгрейд_сервера_уже_принята": "The request for a server upgrade has already been accepted and is being processed",
  "Поздравляем": "Congratulations",
  "Заявка_успешно_принята": "Your application has been successfully submitted, and the upgrade will be carried out on the specified date.",
  "Отлично": "Great",
  "Смена_тарифа": "Upgrade tariff",
  "Текущий_тариф": "Current tariff",
  "Изменить_на": "Upgrade to",
  "Выбрать_дату": "Choose date",
  "Подать_заявку": "Submit an application",
  "Внимание_Ваш_сервер": "Attention! Your server will be offline for up to 1 hour. During an upgrade, login details (IP:port, username, and password) may change in some cases. All your data will be preserved, and the rental will be recalculated according to the new tariff.",
  "Вы_выбрали_проведение_апгрейда_в": "You have chosen to upgrade on trading day! When upgrading, you will need to turn off the server for up to 1 hour!",

  "VPS PAGE Servers Modal Prolongate": "====================",
  "Выберите_период": "Select period",
  "Продление_сервера": "Server renewal",
  "К_оплате": "To pay",
  "Срок_продления": "Renewal period",
  "Далее": "Next",

  "VPS PAGE Servers Modal Credentials": "====================",
  "IP_скопирован": "IP copied",
  "Логин_скопирован": "Login copied",
  "Пароль_скопирован": "Password copied",
  "Данные_при_входе": "Login credentials",
  "IP_адрес": "IP address",
  "Логин": "Login",
  "Пароль": "Password",
  "Скачать_файл_для_входа_на_VPS": "Download the file to access VPS",
  "Воспользуйтесь_удобной_функцией": "Use the convenient quick access feature to VPS. Click the button above, run the downloaded file, and enter the VPS password.",

  "VPS PAGE Servers Modal Control": "====================",
  "Запрос_на_включение": "Server activation request sent successfully",
  "Сервер_включен": "Server is activated",
  "Сервер_отозван": "Server is revoked",
  "Предыдущий_запрос": "The previous request is still being processed. Processing time is 1-2 minutes.",
  "Некорректные_данные": "Incorrect data - contact support",
  "Запрос_на_выключение": "Server shutdown request sent successfully",
  "Сервер_выключен": "Server is shut down",
  "Запрос_на_перезагрузку": "Server restart request sent successfully",
  "Включить": "Turn on",
  "Отключить": "Turn off",
  "Перезагрузить": "Restart",

  "MONITORING PAGE": "====================",
  "Подписка": "Subscription",
  "Мои_счета": "My accounts",
  "Гайд": "Guide",

  "MONITORING SUBSCRIPTION PAGE": "====================",
  "Бесплатное_предложение_недоступно": "The free version of monitoring is not available",
  "Код_активации_успешно_скопирован": "Activation code successfully copied",
  "Подписка_FREE_активирована": "Subscription FREE is activated",
  "Мониторинг": "Monitoring",
  "Конструктор_отчетов": "Report builder",
  "Расширенные_настройки": "Advanced settings",
  "счет_на_мониторинге": "account on monitoring",
  "Как_пользоваться_мониторингом": "How to use monitoring",
  "Кол_во_счетов": "Number of accounts",
  "Кол_во_месяцев": "Number of months",
  "Активировать": "Activate",
  "Количество_счетов_от_1_до_50": "Maximum number of accounts 50",
  "Количество_месяцев_от_1_до_12": "Maximum number of months 12",
  "Платная_подписка_уже_активирована": "Paid subscription is already activated",
  "Введите_количество_счетов": "Enter the number of accounts",
  "Введите_количество_месяцев": "Enter the number of months",
  "Оплата_подписки": "Subscription payment",
  "Продление_подписки": "Subscription renewal",
  "HTML_код_успешно_скопирован": "HTML code successfully copied",
  "BB_код_успешно_скопирован": "BB code successfully copied",
  "Ссылка_успешно_скопирована": "Link successfully copied",
  "Поделиться_мониторингом": "Share monitoring",
  "HTML_код": "HTML code",
  "BB_код": "BB code",
  "Ссылка": "Link",
  "Виджет": "Widget",

  "MONITORING SUBSCRIPTION=Advisor": "====================",
  "Cкачать_советник": "Download advisor",
  "Скачать_для": "Download for",
  "версия": "version",

  "MONITORING SUBSCRIPTION=Table": "====================",
  "Подписки": "Subscriptions",
  "Доступно_счетов": "Accounts available",
  "Дата_активации": "Activation date",
  "Автопродление_позволит_вам": "Auto-renewal allows you to automatically pay for the extension of your monitoring subscription from your personal account balance. To activate this feature, ensure that your personal account balance is topped up with the required amount.",
  "Добавить_кол_во_счетов": "Add number of accounts",
  "Добавить_счёт": "Add account",
  "Приобрести": "Purchase",
  "Введите_количество_добавляемых_счетов": "Enter the number of accounts to add",
  "Добавить_счета": "Add accounts",
  "Введите_кол_во_счетов": "Enter the number of accounts",
  "Внимание_Добавление_счетов": "When adding accounts to a subscription, the subscription end date does not change. The payment invoice will show the amount for the added monitorings until the end of the current subscription period. So, if there are 15 days left until the end of the subscription, the payment invoice will be 'number of monitorings' multiplied by 'number of days'.",

  "MONITORING ACCOUNTS PAGE": "====================",
  "Создать_мониторинг": "Create monitoring",
  "Подписка_не_позволяет_добавлять": "Subscription does not allow adding monitoring",
  "Статус_подписки_не_позволяет_добавлять": "Subscription status does not allow adding monitoring",
  "Добавьте_счета_в_подписку_для_подключения": "Add accounts to subscription to create additional monitoring",
  "название": "name",
  "просадка": "drawdown",
  "прибыль": "profit",
  "баланс": "balance",
  "сделки": "trades",
  "просмотры": "views",
  "управление": "control",
  "инфо_прибыль_процент": "Total profit in percentage for the account over the entire monitoring period",
  "инфо_прибыль_валюта": "Total profit in currency for the account over the entire monitoring period",
  "инфо_просадка": "Current drawdown percentage for the trading account at the moment",
  "инфо_баланс": "Trading account balance in currency at the moment",
  "инфо_средства": "Account funds in currency, taking into account open trades",
  "инфо_сделки": "Number of closed trades",
  "инфо_просмотры": "Number of views for this online monitoring",
  "Потеряна_связь_с_терминалом": "Terminal connection lost",
  "Вы_действительно_хотите_удалить_мониторинг": "Are you sure you want to delete monitoring",
  "Удалить": "Delete",
  "Мониторинг_удален_успешно": "Monitoring deleted successfully",
  "Ошибка_при_удалении_Мониторинга": "Monitoring deletion error",
  "Нужно_продлить_подписку": "Subscription needs to be renewed",
  "Мониторинг_успешно_создан": "Monitoring created successfully",
  "Ошибка_при_создании_Мониторинга": "Failure creating monitoring",
  "Код_активации_скопирован": "Activation key copied",
  "Введите_номер_счета": "Enter account number",
  "Введите_название_мониторинга": "Enter monitoring name",
  "Сгенерируйте_код_активации": "Generate activation key",

  "MONITORING ACCOUNT PAGE": "====================",
  "Статистика": "Statistics",
  "Настройки": "Settings",
  "Макс_баланс": "Maximum balance",
  "Пополнения": "Replenishments",

  "MONITORING ACCOUNT STATISTICS PAGE": "====================",
  "Текущие_данные": "Current data",
  "Инфо_Текущие_данные": "Account data for all time",
  "ежедневно": "daily",
  "ежемесячно": "monthly",
  "макс_просадка": "max drawdown",
  "средства": "equity",
  "свободная_маржа": "free margin",
  "История_операций": "Operations history",
  "Кол_во_сделок": "Deals number",

  "MONITORING ACCOUNT SETTINGS PAGE": "====================",
  "Общие": "Common",
  "Номер_счета": "Account number",
  "Название_мониторинга": "Monitoring name",
  "Код_активации": "Activation key",
  "Сгенерировать": "Generate",
  "Уведомления_и_отчеты_о_работе": "You will be able to receive notifications and reports about the online monitoring after you connect the Telegram Bot for monitorings.",
  "Сохранить_изменения": "Save changes",
  "Настройки_мониторинга_обновлены_успешно": "Monitoring settings updated successfully",
  "Ошибка_при_изменении_настроек_мониторинга": "Error updating monitoring settings",
  "Ошибка_при_отключении_Telegram_bot": "Error disconnecting Telegram bot",

  "Отчеты": "Reports",
  "Настройки_отчетов_обновлены_успешно": "Reports settings updated successfully",
  "Ошибка_при_изменении_настроек_отчетов": "Failure updating reports settings",
  "Количество": "Number of",
  "ордеров": "orders",
  "ежедневный_отчет": "daily report",
  "еженедельный_отчет": "weekly report",
  "ежемесячный_отчет": "monthly report",

  "Уведомления": "Notifications",
  "Настройки_уведомлений_обновлены_успешно": "Notification settings updated successfully",
  "Ошибка_при_изменении_настроек_уведомлений": "Error updating notification settings",
  "Достижение_просадки_в_деньгах": "Achieving drawdown in monetary terms",
  "Достижение_просадки_в_процентах": "Achieving drawdown in percentage terms",
  "Контроль_кредитного_плеча_1_к": "Leverage control 1 to",
  "Достижение_уровня_безубытка": "Achieving break-even level",
  "Открытие_ордера": "Opening an order",
  "Закрытие_ордера": "Closing an order",
  "сетки_ордера": "order grid",
  "Связь_с_терминалом": "Connection to MetaTrader terminal",
  "Введите_значение": "Enter value",
  "Введите_шаг": "Enter step",
  "Значение": "Value",
  "Шаг": "Step",

  "PARTNERS PAGE": "====================",
  "Партнерская_программа": "Partner program",
  "Всего_клиентов": "Total clients",
  "Клиенты_первого_уровня": "1st level clients",
  "Клиенты_второго_уровня": "2nd level clients",
  "Клиенты_третьего_уровня": "3rd level clients",

  "Парнерская_ссылка_скопирована": "Partner link copied!",
  "Парнерский_код_скопирован": "Partner code copied!",
  "Вывод": "Withdrawal",
  "Партнерское_вознаграждение": "Partner reward",
  "Партнерское_вознаграждение_info": "Partner reward - a percentage of the purchase amount from the client you attract, which you will receive for life for each purchase or service renewal by the client you attract.",
  "Ваша_партнерская_ссылка": "Your partner link",
  "Если_пользователь_кликнет": "If a user follows your partner link and rents a VPS, you will receive a percentage of their payment amount, as well as from all subsequent payments. The partner reward amount is displayed in the top left block of the partner section, under 'Partner Reward'.",
  "Ваш_партнерский_код": "Your partner code",
  "Партнерский_код_это": "The partner code is an alternative to the partner link. Share your partner code with the user, and during registration, they will need to enter it in the corresponding field of the registration form, ensuring that the client is 100% attributed to your partner group.",

  "PARTNERS Withdraw Modal": "====================",
  "Выберите_метод_вывода": "Choose withdrawal method",
  "Введите_кошелек": "Enter wallet",
  "Минимальная_сумма_вывода": "The minimum withdrawal amount is",
  "Недостаточно_средств_на_балансе": "Insufficient funds on the partner balance",
  "Ошибка_при_выводе": "Withdrawal request error",
  "Вывод_партнерского_вознаграждения": "Partner reward withdrawal",
  "Метод_вывода": "withdrawal method",
  "Кошелек": "Wallet",
  "Сумма": "Amount",
  "Создать": "Create",
  "Минимальная_сумма_для_вывода": "The minimum amount for withdrawing partner rewards is",
  "Заявка_на_вывод_обрабатывается": "The withdrawal request is processed within 5 working days.",
  "Заявка_на_вывод_создана": "A request to withdraw partner rewards has been created. Once the request is processed, you will receive a notification via E-mail. Please wait.",
  "Внимание": "Attention",
  "Подача_новой_заявки": "You will be able to submit a new request for partner reward withdrawal after the processing of your previous request",

  "PARTNERS Statistics Servers": "",
  "Статистика_по_аренде_VPS": "VPS rental statistics",
  "Выбор_периода": "Specify period",
  "Клики": "Clicks",
  "Клики_info": "Total number of clicks on your partner link for the selected period",
  "Регистрации": "Registrations",
  "Регистрации_info": "Number of clients registered through your partner link for the selected period",
  "Арендованные_VPS": "Rented VPS",
  "Арендованные_VPS_info": "Number of servers purchased by clients from your partner group for the selected period",
  "Продленные_VPS": "Renewed VPS",
  "Продленные_VPS_info": "Number of payments for server renewals by clients from your partner group for the selected period",
  "Вознаграждение": "Reward",
  "Вознаграждение_VPS_info": "Total amount of partner rewards received for the selected period",
  "Конверсия": "Conversion",
  "Конверсия_info": "Conversion rate is the ratio of user clicks on the partner link that resulted in a server purchase to the total number of clicks for the selected period",
  "за_продажу": "per sale",
  "за_продление": "per renew",
  "Всего": "Total",

  "PARTNERS Statistics Clients": "",
  "Статистика_по_клиентам": "Clients statistics",
  "Статистика_по_клиентам_info": "Partner reward statistics by levels",
  "Процент": "Percent",
  "Процент_info": "Partner reward percentage corresponding to the level",
  "Клиентов": "Clients",
  "Оборот": "Volume",
  "Оборот_info": "Total number of purchases and server renewals by attracted clients at the specified level",
  "Вознаграждение_info": "Total amount of your partner reward corresponding to the level",

  "PARTNERS Network": "====================",
  "Партнерская_сеть": "Partner network",
  "Партнерская_сеть_info": "Your structure of attracted clients",
  "Уровень": "Level",
  "Дата_регистрации": "Registration date",

  "PARTNERS Promocodes": "====================",
  "Промокод_удален_успешно": "Promocode deleted successfull",
  "Генератор_промокодов": "Promocode generator",
  "Генератор_промокодов_info": "The promo code generator allows a partner to generate a promo code that users can use to get a discount when renting a VPS for 1 month.",
  "Использовано": "Number of uses",

  "PARTNERS Modal Promocode": "====================",
  "Укажите_название_промокода": "Specify promocode name",
  "Выберите_скидку": "Select discount",
  "Код_успешно_создан": "The promocode has been successfully created and is ready for use!",
  "Cоздать_промокод": "Create promocode",
  "Название_промокода": "Promocode name",
  "Размер_скидки": "Discount amount",
  "Доступный_размер_скидки_зависит": "The available discount depends on the number of active clients you refer (more details in the FAQ)",

  "OPERATIONS PAGE": "====================",
  "Балансовые": "Balance",
  "операции": "operations",
  "Ваш_баланс": "Your balance",

  "OPERATIONS Deposit": "====================",
  "Пополнить_баланс": "Top up balance",
  "Введите_сумму_пополнить": "Enter the amount you want to top up",
  "Сумма_пополнения": "Top-up amount",
  "Пополнить": "Top up",
  "Пополнение_баланса_личного_кабинета": "Topping up your personal account balance will allow you to use the auto-renewal feature. This means that the renewal of your VPS rental will be automatically paid from your account balance.",

  "OPERATIONS Modal Deposit": "====================",
  "Укажите_метод_пополнения": "Specify deposit method",
  "Пополнение_баланса": "Balance top-up",
  "Метод_пополнения": "Top-up method",

  "OPERATIONS Transfer": "====================",
  "Произошла_ошибка_при_переводе": "An error occurred during the transfer. Please try again later.",
  "Перевод_между_счетами": "Transfer between accounts",
  "Введите_сумму_перевода": "Enter the transfer amount and the recipient's e-mail address",
  "Недостаточный_баланс": "Insufficient funds for the transfer",
  "Email_не_существует": "E-mail does not exist",
  "Сумма_перевода": "Transfer amount",
  "Email_получателя": "Recipient's e-mail",
  "Перевести": "Transfer",
  "Перевод_средств_позволит": "Transferring funds allows you to send money from your account balance to the account balance of another user registered in the system.",

  "OPERATIONS Modal Transfer Success": "====================",
  "Заявка_на_перевод_создана": "The transfer request was successfully completed, and the funds have been transferred to the specified client.",

  "OPERATIONS Filter": "====================",
  "История_пополнений": "Balance Payments",
  "История_переводов": "Funds transfers",
  "История_платежей": "Server payments",
  "История_выводов": "Withdrawals of partner rewards",
  "История_пополнений_инфо": "Payment history for account balance top-up",
  "История_переводов_инфо": "History of fund transfers between accounts",
  "История_платежей_инфо": "History of payments for purchases and renewals of VPS servers",
  "История_выводов_инфо": "History of partner reward withdrawals",

  "OPERATIONS Transactions": "====================",

  "Получен": "Recieved",
  "Отправлен": "Sent",

  "На_рассмотрении": "Under review",
  "Выплачен": "Paid out",
  "Отменен": "Cancelled",

  "Оплачен": "Paid",
  "Не_оплачен": "Not paid",
  "В_обработке": "Processing",
  "Отклонен": "Rejected",

  "Платежа": "Payment",
  "Сервер": "Server",
  "Платежная_система": "Payment system",
  "Дата": "Date",

  "Cумма": "Amount",
  "Удален": "Deleted",

  "SUPPORT PAGE": "====================",

  "SUPPORT Create ticket": "====================",
  "Вопросы_по_VPS": "Questions about VPS",
  "Вопросы_по_Партнерке": "Questions about the Partner Program",
  "Вопросы_по_платежам": "Questions about payments",
  "Другие_вопросы": "Other questions",
  "Файл_успешно_добавлен": "File successfully added",
  "Размер_файла_превышает_5": "File size exceeds 5MB",
  "Поддерживаемые_форматы": "Supported formats: jpeg, gif, png, pdf",
  "Максимальный_размер_файла": "Maximum size: 5 MB",
  "Файл_успешно_удален": "File successfully deleted",
  "Выберите_раздел": "Select department",
  "Введите_заголовок_вопроса": "Enter the question title",
  "Введите_текст_вопроса": "Enter the question text",
  "Максимальное_количество_символов": "Maximum number of characters is 1024",
  "Создать_тикет": "Create ticket",
  "Заголовок_вопроса": "Question title",
  "Текст_вопроса": "Question text",
  "Загрузить_файл": "Upload file",
  "Отправить": "Send",
  "у_вас_имеется_открытый_тикет": "Dear client, you currently have an open ticket in this section. The option to open a new ticket in this section will become available after the current issue is closed. You can continue the dialogue in the open ticket.",

  "SUPPORT Tickets list": "====================",
  "Новый": "New",
  "Закрыт": "Closed",
  "Рассмотрение": "Processing",
  "Тикеты": "Tickets",
  "Заголовок": "Title",

  "TICKET PAGE": "====================",
  "Тикет": "Ticket",
  "Создан": "Created",
  "Файлы": "Files",

  "TICKET Dialog": "====================",
  "Тикет_был_закрыт": "The ticket was closed. If you want to resume the discussion, write a message",
  "Закрыть_тикет": "Close ticket",
  "Введите_текст_сообщения": "Enter the message text",
  "Введите_сообщение": "Enter your message",
  "Имя_файла": "File name",

  "PROFILE PAGE": "====================",
  "Профиль": "Profile",
  "Сохранить": "Save",

  "Profile Change Avatar": "====================",
  "Размер_файла_превышает_1": "File size exceeds 1 Мb",
  "Фото_успешно_удален": "Photo deleted successfull",
  "Произошла_ошибка_при_удалении_фото": "An error occurred while deleting the photo",
  "Cменить_фото": "Update photo",
  "Загрузить": "Upload",
  "Максимальный_размер_фото": "Maximum photo size is up to",

  "Profile Change Password": "====================",
  "Для_изменения_пароля": "To change your password, enter your old password",
  "Личная_информация": "Personal information",
  "Сменить_пароль": "Change password",
  "Имя": "Name",
  "Старый_пароль": "Old password",
  "Повторить_новый_пароль": "Repeat new password",
  "Пароль_изменен": "Password updated successfull",
  "Ошибка_при_измененении_пароля": "An error occured while updating password",

  "Profile Telegram Bot": "====================",
  "Телеграм_бот": "Telegram bot",
  "Подключить": "Connect",
  "Отписаться": "Unsubscribe",
  "Успешно_отключен": "Disconnect success",
  "Подключив_Telegram_bot_вы_сможете": "By connecting the Telegram bot, you will be able to receive notifications about the upcoming expiration of the rental period for connected services and extend them in a timely manner.",

  "FAQ PAGE": "====================",
  "Быстрый_поиск_ответа": "Quick answer search",
  "Задать_вопрос_службе_поддержки": "Ask support a question",
  "Поиск": "Search",

  "": ""
}
